import React from 'react';
import EventList from '../components/events/EventList';

const EventsPage: React.FC = () => {
  return <EventList />;
};

export default EventsPage;
